import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "../../../../components/Button";
import { Icon } from "../../../../components/Icon";
import ArrowIcon from "../../../../icons/arrow.svg";
import styles from "./BackButton.module.scss";
export const BackButton = ({ onClick, buttonLabel }) => (_jsx("div", { className: styles.container, children: _jsxs(Button, { className: styles.button, color: "tertiary", onClick: onClick, "data-testid": "qrAgeVerificationBackButton", children: [_jsx(Icon, { rotate: 270, component: ArrowIcon }), buttonLabel] }) }));
//# sourceMappingURL=BackButton.js.map